import React from "react";

const NoInternet = () => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "#fff",
      zIndex: 9999,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <h2>No Internet Connection</h2>
    <p>Please check your network and try again.</p>
  </div>
);

export default NoInternet;
